<template>
    <el-dialog :visible.sync="showModal" :title="modalTitle" :close-on-click-modal="false" :destroy-on-close="true" center
        append-to-body width="600px">
        <div>
            <div v-if="!isUploadFlag">
                <h3>修改订单状态为（被关闭时的状态）</h3>
                <!-- <b style="margin: 15px 15px;">{{ isFirst ? '待提交初稿' : '待提交终稿' }}</b> -->

                <el-tag v-if="draftData.before_state === 0" type="danger">申请中</el-tag>
                <el-tag v-else-if="draftData.before_state === 1" type="danger">申请成功</el-tag>
                <el-tag v-else-if="draftData.before_state === -1" type="danger">申请失败</el-tag>
                <el-tag v-else-if="draftData.before_state === 2" type="danger">已发货</el-tag>
                <el-tag v-else-if="draftData.before_state === 3" type="danger">待提交初稿</el-tag>
                <el-tag v-else-if="draftData.before_state === 4" type="danger">待审核初稿</el-tag>
                <el-tag v-else-if="draftData.before_state === 5" type="danger">初稿审核失败</el-tag>
                <el-tag v-else-if="draftData.before_state === 6" type="danger">待提交终稿</el-tag>
                <el-tag v-else-if="draftData.before_state === 7" type="danger">待审核终稿</el-tag>
                <el-tag v-else-if="draftData.before_state === 8" type="danger">终稿审核失败</el-tag>
                <el-tag v-else-if="draftData.before_state === 9" type="danger">已完成</el-tag>
                <el-tag v-else-if="draftData.before_state === 10" type="danger">订单已关闭</el-tag>
                <el-tag v-else-if="draftData.before_state === 11" type="danger">订单取消</el-tag>
                <el-tag v-else-if="draftData.before_state === 12" type="danger">选择我不去了</el-tag>
                <el-tag v-else-if="draftData.before_state === 13" type="danger">待发放积分</el-tag>
                <el-tag v-else type="danger">后端无字段</el-tag>

                <h3>请修改测评活动“截止时间”</h3>
                <div style="margin: 15px 15px;">
                    <el-form :model="updateForm" ref="updateForm" label-width="120px" :rules="rules">
                        <el-form-item label="初稿截止时间" prop="end_first_submit_at">
                            <el-date-picker v-model="updateForm.end_first_submit_at" type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间" />
                        </el-form-item>
                        <el-form-item label="终稿截止时间" prop="end_final_submit_at">
                            <el-date-picker v-model="updateForm.end_final_submit_at" type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间" />
                        </el-form-item>
                        <!--  -->
                        <el-form-item v-if="isQuestionFlag" label="问卷截止时间" prop="end_questionnaire_at">
                            <el-date-picker v-model="updateForm.end_questionnaire_at" type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间" />
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div v-else>
                <h3>管理员上传内容</h3>
                <h3 style="margin: 15px 25px 25px;">{{ isFirst ? '提交初稿' : '提交终稿' }}</h3>
                <h3>修改并提交</h3>
                <el-form ref="submitFirstForm" :model="submitFirstForm" style="max-width: 500px;">

                    <template v-if="isFirst">
                        <h3>标题</h3>
                        <el-form-item prop="first_draft_title"
                            :rules="{ required: true, message: '请输入标题', trigger: 'blur' }">
                            <el-input placeholder="请输入标题" v-model="submitFirstForm.first_draft_title"
                                style="width: 300px;" />
                        </el-form-item>
                        <h3>内容</h3>
                        <el-form-item prop="first_draft_content"
                            :rules="{ required: true, message: '请输入初稿参考内容', trigger: 'blur' }">
                            <el-input style="width: 400px;" type="textarea" :rows="4" placeholder="请输入初稿参考内容"
                                v-model="submitFirstForm.first_draft_content" />
                        </el-form-item>
                        <h3 style="margin-top: 50px;">{{ isFirst ? '视频/图片' : '测评截图' }}</h3>
                        <el-form-item prop="first_draft_url"
                            :rules="{ required: true, message: '请上传至少一项图片/视频', trigger: 'blur' }">
                            <upload-list :list="submitFirstForm.first_draft_url" width="150px" height="150px"></upload-list>
                        </el-form-item>
                    </template>

                    <template v-else>
                        <!-- <div style="display: flex;align-items: center;">
                            <img style="width: 30px; height: 30px;margin: 0 10px" v-if="platform" :src="platform.path"
                                fit="cover" />
                            <h3>
                                {{ platform.name }}证明链接
                            </h3>
                        </div>
                        <el-form-item prop="final_draft_content" :rules="{ required: true, message: '请输入证明链接', trigger: 'blur' }">
                            <el-input placeholder="" v-model="submitFirstForm.final_draft_content"
                                style="height: 50px;width: 400px;" />
                        </el-form-item> -->

                        <div v-for="item, index in submitFirstForm.channelList" :key="index">
                            <div style="display: flex;align-items: center;" v-if="!(item.id == 4 || item.id == 8)">
                                <img style="width: 30px; height: 30px;margin: 0 10px" :src="item.path" fit="cover" />
                                <h3>
                                    {{ item.name }}证明链接
                                </h3>
                            </div>

                            <el-form-item :prop="'channelList.' + index + '.url'" v-if="!(item.id == 4 || item.id == 8)"
                                :rules="[{ required: true, message: '请输入证明链接', trigger: 'blur' }]">
                                <el-input v-model="item.url" placeHolder="请输入证明链接" style="width: 400px;height: 50px;" />
                            </el-form-item>
                        </div>


                        <h3 style="margin-top: 50px;">{{ isFirst ? '视频/图片' : '测评截图' }}</h3>
                        <el-form-item prop="final_draft_url"
                            :rules="{ required: true, message: '请上传至少一项图片/视频', trigger: 'blur' }">
                            <upload-list :list="submitFirstForm.final_draft_url" width="150px" height="150px"></upload-list>
                        </el-form-item>
                    </template>



                </el-form>

            </div>
        </div>

        <div style="margin-top: 40px;display: flex;align-items: center;justify-content: space-between;">
            <div style="width: 60%;display: flex;align-items: center;justify-content: center;">
                <el-button @click="showModal = false">返回</el-button>
                <el-button v-if="isUploadFlag" type="primary" :loading="submitting"
                    @click="onSubmitFirst('submitFirstForm')" style="margin-left: 50px;">确认</el-button>
                <el-button v-else type="primary" :loading="submitting" @click="onUpdate('updateForm')"
                    style="margin-left: 50px;">确认</el-button>
            </div>

            <el-button @click="goSubmit" v-if="isUploadFlag">修改订单状态</el-button>
            <el-button @click="goSubmit" v-else :disabled="submitDisabled">直接提交资料</el-button>
        </div>



    </el-dialog>
</template>
  
<script>
import UploadList from "@/components/UploadList/index.vue";
import Tinymce from "@/components/Tinymce";
import { zhongcao } from "@/api/order";
import { checkPlatform } from '@/utils/common'

export default {
    data() {
        var valiTimeCorrectness = ({ field }, value, callback) => {
            const formatTime = new Date(value)
            let now = new Date().getTime()
            console.log('rule', field);
            console.log('value', value);
            console.log('formatTime', formatTime);
            console.log('now', now);


            switch (field) {
                case 'end_first_submit_at':
                    if (formatTime < new Date(now)) { callback(new Error('初稿截止时间不能早于当前时间')); } else {
                        callback()
                    }
                    break;
                case 'end_final_submit_at':
                    if (formatTime < new Date(now)) { callback(new Error('终稿截止时间不能早于当前时间')); }
                    else { callback() }
                    break;

                case 'end_questionnaire_at':
                    if (formatTime < new Date(now)) { callback(new Error('问卷截止时间不能早于当前时间')) } else {
                        callback()
                    }
                    break;
                default:
                    throw Error("喵喵喵?")
            }

            // callback();
        }

        return {
            rules: {
                end_first_submit_at: [
                    { required: true, message: "请选择初稿截止时间", trigger: 'blur' },
                    { validator: valiTimeCorrectness, trigger: "blur" }
                ],
                end_final_submit_at: [
                    { required: true, message: "请选择终稿截止时间", trigger: 'blur' },
                    { validator: valiTimeCorrectness, trigger: "blur" }
                ],
                end_questionnaire_at: [
                    { required: true, message: "请选择问卷截止时间", trigger: 'blur' },
                    { validator: valiTimeCorrectness, trigger: "blur" }
                ],
            },
            submitFirstForm: {
                order_id: '',
                channelList: [],

                first_draft_title: '',
                first_draft_content: '',
                first_draft_url: [],

                final_draft_content: '',
                final_draft_url: [],
            },
            videoType: ['mp4', 'rmvb', 'wmv', 'avi', 'mov', 'flv'],
            updateForm: {
                order_id: '',
                end_first_submit_at: '', // 初稿截止时间
                end_final_submit_at: '', // 终稿截止时间
                end_questionnaire_at: '', // 问卷截止时间
            },
            submitting: false,
            isUploadFlag: false,
            isFirst: true,
            isQuestionFlag: true,
            submitDisabled: false,
        }
    },
    components: {
        UploadList, Tinymce
    },
    props: {
        // 展示
        show: {
            default: false,
            type: Boolean,
        },
        draftData: Object,

    },
    methods: {
        goSubmit() {
            this.isUploadFlag = !this.isUploadFlag
        },
        trunOff() {
            this.showModal = false;
        },
        onUpdate(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    try {
                        this.submitting = true;
                        await zhongcao.updateState(this.updateForm);
                        this.$message({
                            message: "已修改订单状态!",
                            type: "success",
                        });
                        this.$emit("onUpdate");
                        this.trunOff();
                    } catch {
                        this.$message.error("出错了!");
                    } finally {
                        this.submitting = false;
                    }
                }
            });
        },
        onSubmitFirst(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    try {
                        this.submitting = true;
                        if (this.isFirst) {
                            let first_draft_url = this.submitFirstForm.first_draft_url.map((item) => {
                                return {
                                    path: item,
                                    type: this.videoType.indexOf(item.substring(item.lastIndexOf('.') + 1)) == -1 ? 1 : 2
                                }
                            })
                            // let first_draft_content = {
                            //     [this.draftData.channel_id]: this.submitFirstForm.first_draft_content
                            // }
                            let first_draft_content = {}
                            this.submitFirstForm.channelList.forEach(item => {
                                if (item.id == 4 || item.id == 8) {
                                    // final_draft_content[item.id] = []
                                } else {
                                    first_draft_content[item.id] = item.url
                                }
                            })
                            const { first_draft_title, order_id } = this.submitFirstForm
                            await zhongcao.firstDraftSubmit({ type: 3, first_draft_title, first_draft_content, first_draft_url, order_id });
                            this.$message({
                                message: "已提交初稿!",
                                type: "success",
                            });
                        } else {



                            let final_draft_url = this.submitFirstForm.final_draft_url.map((item) => {
                                return {
                                    path: item,
                                    type: this.videoType.indexOf(item.substring(item.lastIndexOf('.') + 1)) == -1 ? 1 : 2
                                }
                            })
                            // let final_draft_content = {
                            //     [this.draftData.channel_id]: this.submitFirstForm.final_draft_content
                            // }

                            let final_draft_content = {}
                            this.submitFirstForm.channelList.forEach(item => {
                                if (item.id == 4 || item.id == 8) {
                                    // final_draft_content[item.id] = []
                                } else {
                                    final_draft_content[item.id] = item.url
                                }
                            })
                            const { order_id } = this.submitFirstForm
                            await zhongcao.finalDraftSubmit({ final_draft_content, final_draft_url, order_id });
                            this.$message({
                                message: "已提交终稿!",
                                type: "success",
                            });
                        }

                        this.$emit("onUpdate");
                        this.trunOff();
                    } catch {
                        this.$message.error("出错了!");
                    } finally {
                        this.submitting = false;
                    }
                }
            });
        },
        checkPlatform,

    },
    computed: {
        showModal: {
            get() {
                return this.show;
            },
            set(val) {
                this.$emit("update:show", val);
            },
        },

        modalTitle() {
            return this.isUploadFlag ? '直接上传' : '修改订单状态'
        },
        platform() {
            return this.checkPlatform(2)
            // return this.checkPlatform(this.draftDataObj.channel_id)
        }
    },
    // watch: {
    //     show(val) {
    //         if (val) {
    //             this.form.order_id = this.draftData.order_id
    //         }
    //     }
    // },
    created() {
        let list = this.draftData.channel_id.split(',')
        this.submitFirstForm.channelList = list.map(item => {
            return {
                id: item,
                name: this.checkPlatform(item).name,
                path: this.checkPlatform(item).path,
                url: '',
            }
        })
        console.log('this.submitFirstForm.channelList', this.submitFirstForm.channelList)


        if (this.draftData.before_state === 3 || this.draftData.before_state === 5) {
            this.isFirst = true
        } else if (this.draftData.before_state === 6 || this.draftData.before_state === 8) {
            this.isFirst = false
        } else {
            this.submitDisabled = true
        }
        // this.isQuestionFlag = this.draftData.is_questionnaires_completed=== 1
        this.isQuestionFlag = !(this.draftData.questionnaires_state === null || this.draftData.questionnaires_state === 4 || this.draftData.questionnaires_state === 8)

        this.updateForm.end_first_submit_at = this.draftData.evaluation.end_first_submit_at // 初稿截止时间
        this.updateForm.end_final_submit_at = this.draftData.evaluation.end_final_submit_at // 终稿截止时间
        this.updateForm.end_questionnaire_at = this.draftData.evaluation.end_questionnaire_at // 问卷截止时间
        this.updateForm.order_id = this.submitFirstForm.order_id = this.draftData.order_id // 订单id

        // console.log(this.draftData.questionnaires_state, 'this.draftData.questionnaires_state1111111111111111111111111')
        // console.log(this.isFirst, 'isFirst')
        // console.log(this.isQuestionFlag, 'isQuestionFlag')
        // console.log(this.updateForm, 'updateForm')
        // console.log(this.submitFirstForm, 'this.submitFirstForm')
    },
};
</script>
  
<style lang="scss"></style>
  